import axios from "axios";

const instance = axios.create({
  baseURL: "/",
});

export const setAuthToken = (token) => {
  if (token) {
    // Apply to every request
    instance.defaults.headers.common["Authorization"] = token;
  } else {
    // Delete auth header
    delete instance.defaults.headers.common["Authorization"];
  }
};

export default instance;
